import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Navigate, Route, Routes } from 'react-router-dom'
import { connect } from 'react-redux'

import * as appActions from './actions'
import * as signInActions from '../components/auth/SignIn/actions'
import PrivateRoute from '../components/PrivateRoute'
import Preloader from '../components/UI/Preloader'
import SignIn from '../components/auth/SignIn'
import SignUp from '../components/auth/SignUp'
import SignUpConfirmEmail from '../components/auth/SignUpConfirmEmail'
import PasswordReset from '../components/auth/PasswordReset'
import ChangePassword from '../components/auth/PaswordChange'
import CompleteUserInfo from '../components/auth/CompleteUserInfo'
import ErrorPage from '../components/ErrorPage'
import Update from '../components/Update'

import TimeSheet from '../components/TimeSheet'
import Report from '../components/Report'
import Integrations from '../components/Integrations'
import TaskSettings from '../components/TaskSettings'
import { withRouter } from '../helpers/withRouter.hoc' 

import './App.scss'

class App extends Component {
  static propTypes = {
    tryAutoSignIn: PropTypes.func.isRequired,
    loading: PropTypes.bool.isRequired
  }

  componentDidMount() {
    const { tryAutoSignIn, initAppleAuth } = this.props
    tryAutoSignIn()
    initAppleAuth()
  }

  render() {
    const { loading, role } = this.props
    let content = (
      <div
        style={{
          background: '#506073',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh'
        }}>
        <Preloader />
      </div>
    )

    if (!loading) {
      if (role === 'admin') {
        content = (
          <Routes>
            <Route path="/" element={<PrivateRoute path="/" exact role={role} />} />
            <Route path="/update" element={<PrivateRoute path="/update" exact role={role} element={<Update />} />} />
            <Route path="/error" element={<ErrorPage />} />
            <Route path="/auth" element={<SignIn />} />
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        )
      } else {
        content = (
          <Routes>
            <Route path="/" exact element={<PrivateRoute path="/" exact />} />
            <Route path="/timesheet" exact element={<PrivateRoute path="/timesheet" exact element={<TimeSheet />} />} />
            <Route path="/report" exact element={<PrivateRoute path="/report" exact element={<Report />} />} />
            <Route path="/integrations" exact element={<PrivateRoute path="/integrations" exact element={<Integrations />} />} />
            <Route
              path="/tasksettings/:taskId"
              element={
                <PrivateRoute
                  path="/tasksettings/:taskId"
                  element={<TaskSettings />}
                />
              }
            />
            <Route path="/complete-info" element={<CompleteUserInfo />} />
            <Route
              path="/confirm-email/success"
              element={<SignUpConfirmEmail />}
            />
            <Route
              path="/confirm-email/failure"
              element={<SignUpConfirmEmail />}
            />
            <Route path="/error" element={<ErrorPage />} />
            <Route path="/auth" element={<SignIn />} />
            <Route path="/register" element={<SignUp />} />
            <Route path="/confirm-email" element={<SignUpConfirmEmail />} />
            <Route path="/forgot-password" element={<PasswordReset />} />
            <Route path="/change-password" element={<ChangePassword />} />
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        )
      }
    }
    return content
  }
}

const mapStateToProps = state => ({
  loading: state.app.loading,
  role: state.signIn.role
})

const mapDispatchToProps = dispatch => ({
  tryAutoSignIn: () => dispatch(appActions.autoSignIn()),
  initAppleAuth: () => dispatch(signInActions.initAppleAuth())
})

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(App)
)
